// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create_custom_questions .create_custom_timeline {
  position: relative;
}
.create_custom_questions .create_custom_timeline:before {
  content: " ";
  border: 1px dashed #707070;
  display: inline-block;
  position: absolute;
  left: 8px;
  width: 1px;
  height: 100%;
  z-index: 400;
  border-radius: 1rem;
}
.create_custom_questions .create_custom_timeline li.create_custom_single_timeline {
  margin: 2rem 0;
  margin-left: 2rem;
}
.create_custom_questions .create_custom_timeline li.create_custom_single_timeline::before {
  content: " ";
  background: #B5B5B5;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 1px solid #707070;
  left: 2px;
  width: 14px;
  height: 14px;
  z-index: 400;
}
.create_custom_questions .create_custom_timeline li.create_custom_single_timeline::after {
  content: " ";
  background: #B5B5B5;
  display: inline-block;
  position: absolute;
  border-radius: 50%;
  border: 1px solid #707070;
  left: 2px;
  bottom: 0;
  width: 14px;
  height: 14px;
  z-index: 400;
}
.create_custom_questions .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group {
  margin-bottom: 0.82rem;
  color: #787878;
  background: #F6F6F6;
  border: 1px solid #F6F6F6;
  cursor: pointer;
}
.create_custom_questions .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group:hover, .create_custom_questions .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group.active {
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.0509803922);
  border: 1px solid #B4B4B4;
  border-radius: 5px;
}
.create_custom_questions .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group:hover .card-left i, .create_custom_questions .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group.active .card-left i {
  color: #5BC6FE;
}
.create_custom_questions .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group:last-child {
  margin-bottom: 0;
}
.create_custom_questions .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group h6 {
  color: #555555;
  font-size: 14px;
}
.create_custom_questions .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group p {
  font-size: 12px;
}
.create_custom_questions .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group.add-card {
  background: #ffffff;
  text-align: center;
  padding: 1.15rem 0;
}
.create_custom_questions .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group.add-card:hover, .create_custom_questions .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group.add-card.active {
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.0509803922);
  border: 1px solid #c9c9c9;
  border-radius: 5px;
}
.create_custom_questions .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group .card-right .signle-group {
  margin-right: 10px;
}
.create_custom_questions .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group .card-right .signle-group:first-child {
  margin-left: 6px;
}
.create_custom_questions .create_custom_timeline li.create_custom_single_timeline .custom-groups .single-card-group .card-right .signle-group:last-child {
  margin-right: 0;
}
@media (max-width: 991px) {
  .create_custom_questions .create_custom_timeline li.create_custom_single_timeline .card {
    margin: 10px;
  }
}
.create_custom_questions .create_custom_timeline .card {
  position: relative;
}
.create_custom_questions .create_custom_timeline .card .branches-list li,
.create_custom_questions .create_custom_timeline .card .subjects-list li,
.create_custom_questions .create_custom_timeline .card .sections-list li {
  cursor: pointer;
  border-radius: 2px;
  padding: 0.3rem 0.5rem;
  margin-left: 0.2rem;
  margin-bottom: 0.2rem;
  text-transform: uppercase;
  list-style-type: none;
}
.create_custom_questions .create_custom_timeline .card .branches-list li:hover, .create_custom_questions .create_custom_timeline .card .branches-list li.active,
.create_custom_questions .create_custom_timeline .card .subjects-list li:hover,
.create_custom_questions .create_custom_timeline .card .subjects-list li.active,
.create_custom_questions .create_custom_timeline .card .sections-list li:hover,
.create_custom_questions .create_custom_timeline .card .sections-list li.active {
  cursor: pointer;
  border-radius: 2px;
  background: #EFEFEF;
  padding: 0.3rem 0.5rem;
}

.Create_Question_Paper_type {
  position: relative;
}
.Create_Question_Paper_type a {
  text-decoration: none;
  color: #1B2430;
}
.Create_Question_Paper_type a .single-card {
  position: relative;
}
.Create_Question_Paper_type a .single-card:hover, .Create_Question_Paper_type a .single-card:focus {
  box-shadow: 0 0.5rem 1rem rgba(66, 45, 45, 0.15) !important;
}
.Create_Question_Paper_type a .single-card .icons {
  position: absolute;
  left: 20px;
  top: 15px;
  width: 70px;
  height: 70px;
  line-height: 80px;
  border-radius: 50%;
  text-align: center;
  color: #1B2430;
  border: 1px solid #DEDEDE;
  background: #DEDEDE;
  margin-bottom: -8rem;
}
.Create_Question_Paper_type a .single-card .icons i {
  font-size: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/neetjee_guru/components/questioners/create_question_paper/create_custom_questions/_createcustomquestions.scss"],"names":[],"mappings":"AACI;EACI,kBAAA;AAAR;AAEQ;EACI,YAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AAAZ;AAGQ;EACI,cAAA;EACA,iBAAA;AADZ;AAGY;EACI,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AADhB;AAIY;EACI,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAFhB;AAKY;EACI,sBAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,eAAA;AAHhB;AAKgB;EAEI,oDAAA;EACA,yBAAA;EACA,kBAAA;AAJpB;AAMoB;EACI,cAAA;AAJxB;AAQgB;EACI,gBAAA;AANpB;AASgB;EACI,cAAA;EACA,eAAA;AAPpB;AAUgB;EACI,eAAA;AARpB;AAWgB;EACI,mBAAA;EACA,kBAAA;EACA,kBAAA;AATpB;AAWoB;EAEI,oDAAA;EACA,yBAAA;EACA,kBAAA;AAVxB;AAcgB;EACI,kBAAA;AAZpB;AAcoB;EACI,gBAAA;AAZxB;AAeoB;EACI,eAAA;AAbxB;AAkBY;EACI;IACI,YAAA;EAhBlB;AACF;AAoBQ;EACI,kBAAA;AAlBZ;AAuBgB;;;EACI,eAAA;EACA,kBAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;AAnBpB;AAqBoB;;;;;EAEI,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAhBxB;;AAwBA;EACI,kBAAA;AArBJ;AAuBI;EACI,qBAAA;EACA,cAAA;AArBR;AAuBQ;EACI,kBAAA;AArBZ;AAuBY;EAEI,2DAAA;AAtBhB;AAyBY;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;AAvBhB;AAyBgB;EACI,eAAA;AAvBpB","sourcesContent":[".create_custom_questions {\n    .create_custom_timeline {\n        position: relative;\n\n        &:before {\n            content: ' ';\n            border: 1px dashed #707070;\n            display: inline-block;\n            position: absolute;\n            left: 8px;\n            width: 1px;\n            height: 100%;\n            z-index: 400;\n            border-radius: 1rem;\n        }\n\n        li.create_custom_single_timeline {\n            margin: 2rem 0;\n            margin-left: 2rem;\n\n            &::before {\n                content: ' ';\n                background: #B5B5B5;\n                display: inline-block;\n                position: absolute;\n                border-radius: 50%;\n                border: 1px solid #707070;\n                left: 2px;\n                width: 14px;\n                height: 14px;\n                z-index: 400;\n            }\n\n            &::after {\n                content: ' ';\n                background: #B5B5B5;\n                display: inline-block;\n                position: absolute;\n                border-radius: 50%;\n                border: 1px solid #707070;\n                left: 2px;\n                bottom: 0;\n                width: 14px;\n                height: 14px;\n                z-index: 400;\n            }\n\n            .custom-groups .single-card-group {\n                margin-bottom: 0.82rem;\n                color: #787878;\n                background: #F6F6F6;\n                border: 1px solid #F6F6F6;\n                cursor: pointer;\n\n                &:hover,\n                &.active {\n                    box-shadow: 0px 3px 10px #0000000D;\n                    border: 1px solid #B4B4B4;\n                    border-radius: 5px;\n\n                    .card-left i {\n                        color: #5BC6FE;\n                    }\n                }\n\n                &:last-child {\n                    margin-bottom: 0;\n                }\n\n                h6 {\n                    color: #555555;\n                    font-size: 14px;\n                }\n\n                p {\n                    font-size: 12px;\n                }\n\n                &.add-card {\n                    background: #ffffff;\n                    text-align: center;\n                    padding: 1.15rem 0;\n\n                    &:hover,\n                    &.active {\n                        box-shadow: 0px 3px 10px #0000000D;\n                        border: 1px solid #c9c9c9;\n                        border-radius: 5px;\n                    }\n                }\n\n                .card-right .signle-group {\n                    margin-right: 10px;\n\n                    &:first-child {\n                        margin-left: 6px;\n                    }\n\n                    &:last-child {\n                        margin-right: 0;\n                    }\n                }\n            }\n\n            @media (max-width: 991px) {\n                .card {\n                    margin: 10px;\n                }\n            }\n        }\n\n        .card {\n            position: relative;\n\n            .branches-list,\n            .subjects-list,\n            .sections-list {\n                li {\n                    cursor: pointer;\n                    border-radius: 2px;\n                    padding: 0.3rem 0.5rem;\n                    margin-left: 0.2rem;\n                    margin-bottom: 0.2rem;\n                    text-transform: uppercase;\n                    list-style-type: none;\n\n                    &:hover,\n                    &.active {\n                        cursor: pointer;\n                        border-radius: 2px;\n                        background: #EFEFEF;\n                        padding: 0.3rem 0.5rem;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.Create_Question_Paper_type {\n    position: relative;\n\n    a {\n        text-decoration: none;\n        color: #1B2430;\n\n        .single-card {\n            position: relative;\n\n            &:hover,\n            &:focus {\n                box-shadow: 0 0.5rem 1rem rgba(66, 45, 45, 0.15) !important\n            }\n\n            .icons {\n                position: absolute;\n                left: 20px;\n                top: 15px;\n                width: 70px;\n                height: 70px;\n                line-height: 80px;\n                border-radius: 50%;\n                text-align: center;\n                color: #1B2430;\n                border: 1px solid #DEDEDE;\n                background: #DEDEDE;\n                margin-bottom: -8rem;\n\n                i {\n                    font-size: 2rem;\n                }\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
